import { VelaInput, VelaTemplate } from '@usimweb/core/models';
import * as fromTree from '../actions/tree.action';
import { MakeEntitie } from '../makeentitie';

export interface TreeState {
  entities: { [uuid: string]: VelaTemplate };
  velaInput: VelaInput;
  loading: boolean;
  loaded: boolean;
}

export const initialState: TreeState = {
  entities: {},
  velaInput: {} as any,
  loading: false,
  loaded: false,
};

export function reducer(state = initialState, action: fromTree.TreeActions): TreeState {
  switch (action.type) {
    case fromTree.LOAD_TREE_STRUCT: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromTree.LOAD_TREE_STRUCT_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromTree.LOAD_TREE_STRUCT_SUCCESS: {
      const templates = action.payload;
      const entities = MakeEntitie.velaTemplate(state, templates);

      const result = {
        ...state,
        entities,
        velaInput: templates[0].input_value,
        loading: false,
        loaded: false,
      };

      return result;
    }

    case fromTree.UPDATE_TREE: {
      const payload = action.payload;

      const newState = { ...state.velaInput, payload };

      return {
        ...state,
        velaInput: newState.payload,
        loading: false,
        loaded: false,
      };
    }

    case fromTree.UPDATE_VALUE_TREE: {
      const payload = action.payload;
      const index = payload.index;
      const data = payload.data;
      const key = payload.key;

      let velaInput: VelaInput;
      if (payload.index >= 0) {
        const newState = Object.values({ ...state.velaInput[key], [index]: data });
        velaInput = { ...state.velaInput, [key]: newState };
      } else {
        velaInput = { ...state.velaInput, [key]: data } as any;
      }

      return {
        ...state,
        velaInput,
      };
    }

    case fromTree.ADD_ACTOR_TREE: {
      const payload = action.payload;

      const data = payload.data as any;

      const tmp = data.name.value.split(':')[0];
      const name = tmp + ' ' + payload.index.toString();
      const index = data.name.index;
      const renamed = { ...data, ['name']: { value: name, index: index } };

      const newState = [...state.velaInput[payload.key], renamed];
      const velaInput = { ...state.velaInput, [payload.key]: newState };

      return {
        ...state,
        velaInput,
      };
    }

    case fromTree.RM_ACTOR_TREE: {
      const payload = action.payload;
      const { [payload.index]: removed, ...newState } = state.velaInput[payload.key];
      const velaInput = { ...state.velaInput, [payload.key]: Object.values(newState) };

      return {
        ...state,
        velaInput,
      };
    }

    case fromTree.CHANGE_TEMPLATE: {
      const velaInput = action.payload;
      return {
        ...state,
        velaInput,
      };
    }
  }

  return state;
}

export const getVelaInput = (state: TreeState) => state.velaInput;
export const getVelaTemplates = (state: TreeState) => state.entities;
export const getVelaInputLoading = (state: TreeState) => state.loading;
export const getVelaInputLoaded = (state: TreeState) => state.loaded;
